export const links = {
  // eslint-disable-next-line max-len
  mobile: "https://ptosrd.com/?siteId=wl3&cobrandId=257522&superCategoryName=&categoryName=&pageName=home&prm%5Bpsid%5D=RedGIFs&prm%5Bpstool%5D=205_1&prm%5Bpsprogram%5D=cbrnd&prm%5Bcampaign_id%5D=124640&subAffId=%7BSUBAFFID%7D&prm%5Butm_source%5D=NewLiveCircle&filters=",
  desktop: "https://rgcams.com/landing/click/?AFNO=1-3",
};
